module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-rnd-cisco.e192448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-rnd-cisco.png
// module id = GKhN
// module chunks = 0